/**
 * Environment Methods
 * Fetch backend runtime library versions for model-compatibility disclaimers.
 */

import { getSession } from '../../../../../core/auth/supabase-auth';
import { getApiBaseUrl } from '../core';
import { EnvironmentInfo } from '../types';

export async function getEnvironmentInfo(): Promise<EnvironmentInfo> {
  const session = await getSession();
  const accessToken = session?.access_token;

  if (!accessToken) {
    throw new Error('No authentication token available. Please log in.');
  }

  const response = await fetch(`${getApiBaseUrl()}/environment-info`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch environment info: ${response.status}`);
  }

  return response.json() as Promise<EnvironmentInfo>;
}
